import cloneDeep from 'lodash/cloneDeep';
import { TeamsActions, TeamsActionTypes } from '@app/store/actionTypes/teamsActionTypes';
import { LocalizedTeam, TeamNames, TeamStatistics } from '@app/types/teamsTypes';
import { TeamSubMenuId } from '@app/types/configurationTypes';

export type TeamsState = {
  teams: {[propName in TeamSubMenuId]?: LocalizedTeam};
  teamsStatistics: {[propName in TeamSubMenuId]?: TeamStatistics};
  teamNames: TeamNames | null;
};

const initialState: TeamsState = {
  teams: {},
  teamsStatistics: {},
  teamNames: null,
};

export default (
  state: TeamsState = cloneDeep(initialState),
  action: TeamsActions,
): TeamsState => {
  switch (action.type) {
    case TeamsActionTypes.SET_TEAM:
      return {
        ...state,
        teams: {
          ...state.teams,
          [action.payload.type]: {
            ...state.teams[action.payload.type],
            ...action.payload.players,
          },
        },
      };
    case TeamsActionTypes.RESET_ALL_TEAMS:
      return {
        ...state,
        teams: { ...initialState.teams },
      };
    case TeamsActionTypes.SET_TEAM_STATISTICS:
      return {
        ...state,
        teamsStatistics: { ...state.teamsStatistics, ...{ [action.payload.type]: action.payload.statistics } },
      };
    case TeamsActionTypes.SET_TEAM_NAMES:
      return {
        ...state,
        teamNames: action.payload,
      };
    case TeamsActionTypes.RESET_ALL_TEAMS_STATISTICS:
      return {
        ...state,
        teamsStatistics: { ...initialState.teamsStatistics },
      };
    default:
      return state;
  }
};
